export default __webpack_public_path__ + "static/media/code_icon.117aacad.svg";